<template>
	<div class="myOrder layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;z-index: 0;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="setClass(1)" v-if="showClass!=1" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i> 月结订单
			</div>
		</div>
		<div>
			<table class="layui-table align_center" id="orders" style="width:90%;margin:0 5%;">
				<thead>
					<tr>
						<th class="align_center">订单编号</th>
						<th class="align_center">结算日期</th>
						<th class="align_center">订单状态</th>
						<th class="align_center">订单数量</th>
						<th class="align_center">钢网数量</th>
						<th class="align_center">订单金额</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in datas" :key="i">
						<td>{{item.order_num}}</td>
						<td>{{item.createtime}}</td>
						<td>{{item.status == 1 ? '未支付' : '已支付'}}</td>
						<td>{{item.order_count}}</td>
						<td>{{item.mesh_count}}</td>
						<td>{{item.price}}</td>
						<td style="display: flex;align-items: center;justify-content: center;">
							<button v-if="item.status == 1" @click="onPay(item.order_num,1)" class="layui-btn layui-btn-sm" style="background: rgb(26,173,25);display: flex;align-items: center;">
								<img class="icons" src="../assets/wx.png" height="20" width="20" alt="" style="margin: 0 5px;">微信支付
							</button>
							<button v-if="item.status == 1" @click="onPay(item.order_num,2)" class="layui-btn layui-btn-sm zt_color" style="display: flex;align-items: center;">
								<img class="icons" src="../assets/zfb.png" height="20" width="20" alt="" style="margin: 0 5px;">支付宝支付
							</button>
							<button v-else class="layui-btn layui-btn-sm layui-btn-disabled">已支付</button>
						</td>
					</tr>
					<tr v-if="datas.length == 0">
						<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="7">暂无数据</td>
					</tr>
				</tbody>
			</table>
			<div id="lypages" style="margin-left: 5%;"></div>
		</div>
		<div id="qrCode" style="display: none;">
			<img :src="'https://mr.summary88.com/'+imgUrl" />
			<p>请打开微信扫码支付</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'myOrder',
		data() {
			return {
				show: false,
				dscModel: false,
				showClass: 1,
				forms: '',
				uploads: '',
				nowTimes: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
				value: '',
				value2: '',
				status: '',
				clasList: [{
						title: '待付款',
						id: 1
					},
					{
						title: '已付款',
						id: 2
					}
				],
				datas: [],
				pages: 1,
				limit: 10,
				count: 1,
				search: 0,
				clear: '',
				imgUrl: '', //二维码url
			}
		},
		created() {
			this.getData();
		},
		mounted() {
			let _this = this;
			layui.use(['form', 'laydate'], () => {
				this.forms = layui.form;
				this.forms.render('select');
				this.forms.on('select(status)', function(data) {
					_this.status = data.value;
				});
				var laydate = layui.laydate;
				laydate.render({
					elem: '#times1', //指定元素
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let start = new Date(y + '/' + m + '/' + d);
						_this.value = new Date(start).getTime() / 1000;
					}
				});
				laydate.render({
					elem: '#times2', //指定元素 
					theme: '#4876FF',
					max: this.nowTimes,
					done: function(value, date, endDate) {
						let time = new Date(value);
						let y = time.getFullYear();
						let m = time.getMonth() + 1;
						let d = time.getDate();
						let end = new Date(y + '/' + m + '/' + d);
						_this.value2 = new Date(end).getTime() / 1000 + 86399;
					}
				});
			});
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['laypage'], () => {
					var laypage = layui.laypage;
					var obj = {
						token: _this.getCookie('token'),
						page: _this.pages,
						limit: _this.limit
					}
					api.cMonthOrderList(obj).then((res) => {
						if(res.code == 1) {
							_this.datas = res.data.list;
							_this.count = res.data.count;

						} else {
							_this.datas = [];
						}
						_this.show = true
						laypage.render({
							elem: 'lypages', //注意，这里的 test1 是 ID，不用加 # 号
							theme: '#4876FF',
							curr: _this.pages,
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getData();
								}
							}
						});
					})
				})
			},
			onPay(num, type) {
				let _this = this;
				layer.msg('加载中', {
					icon: 16,
					shade: 0.01,
				});
				api.getOrderPay({
					token: _this.getCookie('token'),
					order_num: num,
					order_type: 2,
					pay_type: type
				}).then((res1) => {
					if(type == 1) {
						if(res1.code == 1) {
							_this.imgUrl = res1.data;
							layer.closeAll();
							layer.open({
								title: '支付',
								type: 1,
								content: $('#qrCode'),
								resize: false,
								success: function() {
									_this.verify(num);
								},
								cancel: function(index, layero) {
									clearInterval(_this.clear);
								}
							});
						} else {
							layer.msg(res1.msg, {
								icon: 2,
								anim: 6
							})
						}
					} else {
						layer.closeAll();
						let divForm = document.getElementsByTagName('divform')
						if(divForm.length) {
							document.body.removeChild(divForm[0])
						}
						const div = document.createElement('divform');
						div.innerHTML = res1; // data就是接口返回的form 表单字符串
						document.body.appendChild(div);
						document.forms[0].submit();
					}
				})
			},
			verify(num) {
				var _this = this;
				var i = 0;
				clearInterval(_this.clear);
				_this.clear = setInterval(() => {
					i++;
					api.checkPayStatus({
						token: this.getCookie('token'),
						order_type: 2,
						order_num: num
					}).then((res) => {
						if(res.code == 1) {
							clearInterval(_this.clear);
							layer.closeAll();
							layer.msg('支付成功', {
								icon: 1,
								anim: 5
							})
							_this.getData();
						} else {
							if(i == 100) {
								clearInterval(_this.clear);
								layer.closeAll();
								layer.msg('支付超时', {
									icon: 2,
									anim: 6
								})
							}
						}
					})
				}, 3000)
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#qrCode {
		width: 300px;
		padding: 20px 20px 50px;
	}
	
	#qrCode img {
		display: block;
		width: 300px;
		height: 300px;
		margin-bottom: 30px;
	}
	
	#qrCode p {
		font-size: 16px;
		text-align: center;
	}
	
	.jiaji {
		color: rgba(229, 28, 35, 1);
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	.myOrder {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 5% 10px;
	}
	
	#evaluate {
		padding: 0 20px 30px;
	}
	
	#evaluate .title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#evaluate .layui-form {
		display: flex;
		flex-wrap: wrap;
	}
	
	#evaluate .layui-form-item {
		width: 330px;
		margin-bottom: 0;
	}
	
	#evaluate .layui-form-item h3 {
		line-height: 50px;
	}
	
	#evaluate .layui-form-item .star_total {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .star_box .star_list {
		display: flex;
		align-items: center;
	}
	
	#evaluate .layui-form-item .label {
		width: 100px;
		text-align: right;
	}
	
	#evaluate .layui-form-item .tit {
		line-height: 50px;
	}
	
	#evaluate textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	.layui-form-item .preview2 {
		width: 110px;
		height: 110px;
		margin-right: 15px;
		margin-bottom: 30px;
	}
	
	.upload_img2 {
		width: 110px;
		height: 110px;
		margin-bottom: 30px;
	}
	
	#star1,
	#star2,
	#star3,
	#star4,
	#star5,
	#star6,
	#star7,
	#star8,
	#star9,
	#star10 {
		position: relative;
		top: 7px;
		margin-left: 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/monthly.vue